import React from 'react';
import styled from 'styled-components';

const Box = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  position: fixed;
  left: 10rem;
  top: 2rem;
  z-index: 10;
  background-color: rgb(11, 11, 11); /* Green theme */
  padding: 12px 24px;
  border-radius: 8px;
  color: white;
  font-weight: bold;
  font-size: 1rem;
  text-decoration: none;
  transition: background 0.3s ease, transform 0.2s ease;

  /* Hover effects for desktop */
  @media (hover: hover) {
    &:hover {
      background-color: rgb(11, 11, 11);
      transform: scale(1.05);
    }
  }
  
  /* Touch effects for mobile */
  @media (hover: none) {
    &:active {
      background-color: rgb(8, 8, 8);
      transform: scale(1.02);
      transition: all 0.1s ease;
    }
  }

  /* Tablets */
  @media (max-width: 768px) {
    left: 2rem; /* Move to left corner */
    top: 5rem; /* Adjust below logo */
    padding: 8px 16px;
    font-size: 0.9rem;
    border-radius: 6px;
    
    /* Hover effects for desktop */
    @media (hover: hover) {
      &:hover {
        transform: scale(1.03);
      }
    }
    
    /* Touch effects for mobile */
    @media (hover: none) {
      &:active {
        transform: scale(1.01);
      }
    }
  }

  /* Mobile screens */
  @media (max-width: 480px) {
    left: 1rem; /* Keep it on the left corner */
    top: 5rem; /* Move down slightly */
    padding: 6px 14px;
    font-size: 0.85rem;
    border-radius: 5px;
    
    /* Hover effects for desktop */
    @media (hover: hover) {
      &:hover {
        transform: scale(1.02);
      }
    }
    
    /* Touch effects for mobile */
    @media (hover: none) {
      &:active {
        transform: scale(1.01);
      }
    }
  }

  /* Small mobile screens */
  @media (max-width: 320px) {
    padding: 5px 12px;
    font-size: 0.8rem;
  }
`;

const Resume = () => {
  return (
    <Box href="/resume.pdf" target="_blank" rel="noopener noreferrer">
      Resume
    </Box>
  );
};

export default Resume;
